(() => {
  const behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";

  for (const link of document.querySelectorAll(".sustainability__subnav-link")) {
    link.addEventListener("click", (ev) => {
      const target = document.querySelector(link.getAttribute("href") || "");
      if (!(target instanceof HTMLElement)) return;
      ev.preventDefault();
      history.pushState({}, "", link.getAttribute("href"));
      const rect = target.getBoundingClientRect();
      const top = rect.top + window.scrollY - (window.innerHeight - rect.height) / 2;
      window.scrollTo({ top, behavior });
    });
  }
})();

(() => {
  const wrap = document.querySelector(".sustainability__certification-wrap");
  const gallery = document.querySelector(".sustainability__gallery");
  const bandAbove = document.querySelector(".sustainability__pull-quote");
  const partnersFrame = document.querySelector(".sustainability__media--inset .sustainability__media-frame");
  const partnersImage = document.querySelector(".sustainability__media--inset .sustainability__media-image");
  const partnersColumn = document.querySelector(".sustainability__section--framed .sustainability__content");
  const clothSection = document.querySelector(".sustainability__section--flip");
  const zoomTargets = [
    ...document.querySelectorAll(".sustainability__section--flip .sustainability__media-image, .sustainability__location-image"),
  ].filter((el) => el instanceof HTMLElement);

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const DESKTOP_MIN_WIDTH = 900;
  const PAN_LEAD = 0.2;
  const CANVAS_FILL = 1.45;
  const ZOOM_FROM = 1.2;

  const clamp01 = (value) => Math.min(Math.max(value, 0), 1);

  const viewportHeight = () => (window.visualViewport ? window.visualViewport.height : window.innerHeight);

  const timelineProgress = (mobile) => {
    if (!(wrap instanceof HTMLElement)) return 0;
    const wrapTop = wrap.getBoundingClientRect().top;
    if (mobile) return clamp01((mobilePin.stickyTop - (wrapTop + mobilePin.flowTop)) / mobilePin.runway);
    const runway = Math.max(wrap.clientHeight - viewportHeight() - desktopCover, 1);
    return clamp01((desktopLead - wrapTop) / (desktopLead + runway));
  };

  let items = [];
  let baseTravel = 0;
  let desktopLead = 0;
  let desktopCover = 0;
  let panTravel = 0;
  const mobilePin = { flowTop: 0, runway: 1, stickyTop: 0 };

  const measure = () => {
    items = [];
    if (!(wrap instanceof HTMLElement) || !(gallery instanceof HTMLElement)) return;
    const galleryHeight = gallery.clientHeight;
    const images = [];
    for (const el of gallery.querySelectorAll(".sustainability__gallery-image")) {
      if (el instanceof HTMLElement && el.offsetParent !== null) images.push(el);
    }
    let naturalBottom = 0;
    for (const el of images) naturalBottom = Math.max(naturalBottom, el.offsetTop + el.offsetHeight);
    const stretch = naturalBottom > 0 ? Math.max(1, (galleryHeight * CANVAS_FILL) / naturalBottom) : 1;
    let canvasBottom = 0;
    let bottomSpeed = 1;
    for (const el of images) {
      const speed = parseFloat(el.getAttribute("data-speed") || "1");
      const bottom = el.offsetTop * stretch + el.offsetHeight;
      if (bottom > canvasBottom) {
        canvasBottom = bottom;
        bottomSpeed = speed;
      }
      items.push({ el, speed, spread: el.offsetTop * (stretch - 1) });
    }
    baseTravel = Math.max((canvasBottom - galleryHeight) / bottomSpeed, 0);
    const content = wrap.querySelector(".sustainability__certification-content");
    if (content instanceof HTMLElement) {
      mobilePin.flowTop = content.offsetTop + content.offsetHeight + parseFloat(getComputedStyle(gallery).marginTop);
    }
    mobilePin.runway = Math.max(wrap.clientHeight - mobilePin.flowTop - gallery.offsetHeight, 1);
    mobilePin.stickyTop = parseFloat(getComputedStyle(gallery).top) || 0;
    desktopLead = bandAbove instanceof HTMLElement ? bandAbove.offsetHeight : 0;
    const next = wrap.nextElementSibling;
    desktopCover = next instanceof HTMLElement ? Math.max(-parseFloat(getComputedStyle(next).marginTop) || 0, 0) : 0;
    panTravel =
      partnersFrame instanceof HTMLElement && partnersImage instanceof HTMLElement
        ? Math.max(partnersImage.offsetHeight - partnersFrame.offsetHeight, 0) / 2
        : 0;
  };

  const entrance = (top, from, to) => {
    const h = viewportHeight();
    return 1 - clamp01((h * from - top) / (h * (from - to)));
  };

  const update = () => {
    if (items.length > 0) {
      const t = timelineProgress(window.innerWidth < DESKTOP_MIN_WIDTH);
      for (const item of items) {
        item.el.style.setProperty("--drift", `${(item.spread - t * baseTravel * item.speed).toFixed(1)}px`);
      }
    }
    if (partnersFrame instanceof HTMLElement) {
      const rect = partnersFrame.getBoundingClientRect();
      if (panTravel > 0 && partnersImage instanceof HTMLElement) {
        const traversed = (viewportHeight() - rect.top) / (viewportHeight() + rect.height);
        const crossed = clamp01((traversed - PAN_LEAD) / (1 - 2 * PAN_LEAD));
        partnersImage.style.setProperty("--pan", `${(panTravel - crossed * 2 * panTravel).toFixed(1)}px`);
      }
      if (partnersColumn instanceof HTMLElement) {
        partnersColumn.style.setProperty("--enter", entrance(rect.top, 1, 0.5).toFixed(3));
      }
    }
    if (clothSection instanceof HTMLElement) {
      clothSection.style.setProperty("--enter", entrance(clothSection.getBoundingClientRect().top, 0.75, 0.15).toFixed(3));
    }
    for (const el of zoomTargets) {
      const zoom = 1 + (ZOOM_FROM - 1) * entrance(el.getBoundingClientRect().top, 1, 0.35);
      el.style.setProperty("--zoom", zoom.toFixed(4));
    }
  };

  let ticking = false;
  const queue = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      update();
    });
  };

  measure();
  update();
  document.addEventListener("scroll", queue, { passive: true });
  window.addEventListener("resize", () => {
    measure();
    queue();
  });
})();
